var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with (null).")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1796875,45 C15.6484348,45.4531273 15.0898467,45.5351577 14.5039062,45.2460938 C13.9179658,44.9570298 13.625,44.4765659 13.625,43.8046875 L13.625,4.1953125 C13.625,3.52343414 13.9179658,3.06640746 14.5039062,2.82421875 C15.0898467,2.58203004 15.6484348,2.68749773 16.1796875,3.140625 L36.734375,21.890625 C37.4062534,22.500003 37.7421875,23.2539018 37.7421875,24.1523438 C37.7421875,25.0507857 37.4062534,25.796872 36.734375,26.390625 L16.1796875,45 Z",
    id: "directright"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectRight);
export default __webpack_public_path__ + "static/media/direct-right.b8e46b7a43733d596aba506dc1fc7fe7.svg";
export { ForwardRef as ReactComponent };